import React from 'react';
import { useParams } from 'react-router';

import { useProductSection, useProductSections } from '@/features/constructorProducts/hooks';
import { Section } from '@/features/constructorCommon';

export const ProductSection = ({sectionProp, onCreated}) => {
  const { id } = useParams();
  const {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  } = useProductSection({productId: id});
  const { dataSorted, loading, answers, setAnswers } = useProductSections(
    id,
    sectionProp ? sectionProp.visibleConditions : null
  );

  return (
    <Section sectionProp={sectionProp}
             onCreated={onCreated}
             handleCreate={handleCreate}
             handleUpdate={handleUpdate}
             handleDelete={handleDelete}
             isCreating={isCreating}
             isUpdating={isUpdating}
             isDeleting={isDeleting}
             dataSortedSections={dataSorted}
             loadingSections={loading}
             dependentAnswers={answers}
             setDependentAnswers={setAnswers}
             type='products'
    />
  );
};
